import { getRoutePath } from "@/lib/utils";
import type { PushParams } from "@/types/global/route";
import { useNavigate, Navigate } from "react-router-dom";

export const useRoute = () => {
  const navigate = useNavigate();

  return {
    push: (p: PushParams | string) => {
      return navigate(typeof p === "string" ? p : getRoutePath(p));
    },
    pull: () => navigate(-1),
    replace: (p: PushParams | string) => {
      return navigate(typeof p === "string" ? p : getRoutePath(p), {
        replace: true,
      });
    },
    dismissTo: (path = "/") => {
      navigate(path, { replace: true });
    },
  };
};

export const Redirect = ({
  path,
  replace = true,
}: {
  path: string;
  replace?: boolean;
}) => {
  return <Navigate to={path} replace={replace} />;
};
